import { geoConstants, userConstants } from '../constants'
import { geoService } from '../../services'
import { request, success, failure } from './helper'

function getCountry() {
  return async dispatch => {
    dispatch(request(geoConstants.COUNTRY_REQUEST))
    try {
      const country = await geoService.getCountry()
      const { countryCode } = country
      const countryLanguage = await geoService.getCountryLanguage(countryCode)
      const languageCode = countryLanguage && countryLanguage.code
      dispatch(success(geoConstants.COUNTRY_SUCCESS, { countryCode, languageCode }))
    } catch (error) {
      dispatch(failure(geoConstants.COUNTRY_FAILURE, error))
      if (error.errors.errorType === 'BadRequestError') {
        dispatch(failure(userConstants.SECURITY_BLOCKED, error))
      }
    }
  }
}

export default {
  getCountry,
}
